import { t } from 'i18next';
import { months, showDate2 } from 'src/constants';

const OrderReport = ({ data, pageNumber }) => {
  const month = months.find((item) => item.value === new Date(data[0].createdAt).getMonth() + 1)?.label;

  return (
    <div
      id={`page${pageNumber}`}
      style={{
        width: '210mm',
        height: '297mm',
        padding: '4mm',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      {pageNumber === 0 && (
        <section
          style={{ width: '100%', marginBottom: '2mm', height: '12mm', display: 'flex', justifyContent: 'flex-end' }}
        >
          <div
            style={{
              width: '70%',
              height: '100%',
              border: '0.6mm solid black',
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '2mm',
              paddingBottom: '4mm',
            }}
          >
            <h1 style={{ fontWeight: 500, fontSize: '4mm', margin: 0 }}>
              {t('orderReport.heading')} {t(`labels.${month}`).toUpperCase()}
            </h1>
          </div>
        </section>
      )}
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '2mm',
          tableLayout: 'fixed',
        }}
      >
        <thead>
          <tr style={{ backgroundColor: '#c6c6c6', color: 'white', height: '8mm' }}>
            {[
              t('orderReport.dates'),
              t('orderReport.names'),
              t('orderReport.dosage'),
              `${t('orderReport.qty')} LUMUMBA`,
              `${t('orderReport.qty')} MPETI`,
              `${t('orderReport.qty')} ${t('common.customers').toUpperCase()}`,
              `${t('orderReport.amounts')}/$`,
            ].map((header) => (
              <th
                key={header}
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  textAlign: 'center',
                  paddingBottom: '4mm',
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, index) => (
            <tr key={index} style={{ textAlign: 'center', height: '6mm' }}>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {/* Date */}
                {showDate2(row.status.find((item) => item.status === 'IN_PROGRESS')?.createdAt)}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {row.customerId?.firstName + ' ' + row.customerId?.lastName}
                {/* Name */}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {row.dosage ? row.dosage : '-'}
                {/* Dosage */}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {row.customerId?.email === 'lumumbajmc@gmail.com' ? row.volumeOfConcrete : ''}
                {/* Lumumba */}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {row.customerId?.email === 'mpetijmc@gmail.com' ? row.volumeOfConcrete : ''}
                {/* Mpeti */}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {['mpetijmc@gmail.com', 'lumumbajmc@gmail.com'].includes(row.customerId?.email)
                  ? ''
                  : row.volumeOfConcrete}
                {/* Client */}
              </td>
              <td
                style={{
                  border: '0.5mm solid black',
                  fontSize: '3.5mm',
                  paddingBottom: '2mm',
                }}
              >
                {row.amount ? row.amount : '-'}
                {/* Moment$ */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderReport;
